<template>
    <div v-if="lang=='en'">
key4lead does store in a secured database the scans you do and the form you fill-in. This data is intended only to the customer who bought it and will not be transfered to any one else. If you have any question or want to update or delete your personal data, please contact us at <span style="text-decoration:underline">key4lead@key4events.com</span>.
    </div>
    <div v-else>
Le service key4lead dispose de moyens informatiques destinés à gérer les opportunités que vous saisissez. Les informations enregistrées sont réservées à l'usage du service concerné et ne peuvent être communiquées qu'aux destinataires ayant commandé à l'organisation. Depuis la loi n° 78-17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, toute personne peut obtenir communication et, le cas échéant, rectification ou suppression des informations la concernant, en s'adressant au service <span style="text-decoration:underline">key4lead@key4events.com</span>. Toute personne peut également, pour des motifs légitimes, s'opposer au traitement des données la concernant.
    </div>
</template>
<script>

export default {
    computed : {
        lang : function(){
            return this.$route.query.lang;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/l_gdpr/gdpr.vue